import icon from './logos/monelevage-logo-1024x1024-white.svg'

export default icon ;